import * as React from 'react';
import { ISeller, IBuilder } from '../../types/newbuilding';
import { Container } from '../../components/Container';
import { SIZE_8, SIZE_4 } from '../../constants/sizes';
import { ShowPhoneButton } from '../ShowPhoneButton';

interface IShowPhoneButtonContainerProps {
  builders?: IBuilder[];
  sellers?: ISeller[] | null;
  onShowPhonesClick(): void;
  onPhoneClick?(): void;
  newbuildingId: number;
}

export function ShowPhoneButtonContainer(props: IShowPhoneButtonContainerProps) {
  let {
    builders,
    sellers,
    newbuildingId,
  } = props;
  const {
    onShowPhonesClick,
    onPhoneClick,
  } = props;
  sellers = sellers && sellers.filter(({ isBuilder }) => !isBuilder);
  builders = builders && builders.filter(({ phone }) => phone);

  if ((builders && builders.length) || (sellers && sellers.length)) {
    return <Container
      display="inline-block"
      margin={`0 ${SIZE_8} ${SIZE_4} 0`}
    >
      <ShowPhoneButton
        onShowPhonesClick={onShowPhonesClick}
        onPhoneClick={onPhoneClick}
        builders={builders}
        agents={sellers}
        newbuildingId={newbuildingId}
      />
    </Container>;
  }

  return null;
}
